module.exports = {
    "dismiss": `Lukk`
};


//# sourceMappingURL=nb-NO.main.js.map
